import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Ease logo icon (full bleed wave symbol)
 * Source: Design team SVG assets (Icon-FullBleed)
 *
 * Color customization via inputs:
 * - bg: Background fill color (default: #0F3E17 forest)
 * - fg: Foreground/wave fill color (default: #FFFEFC white)
 * - radius: Corner radius for rounded edges (default: 300 for rounded look, use 0 for square)
 *
 * Example usage:
 * <ease-logo-icon />
 * <ease-logo-icon bg="transparent" fg="#0F3E17" />
 * <ease-logo-icon radius="300" />
 */
@Component({
  selector: 'ease-logo-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg viewBox="0 0 2500 2500" fill="none" xmlns="http://www.w3.org/2000/svg" class="tw-w-full tw-h-full">
      <rect width="2500" height="2500" [attr.fill]="bg()" [attr.rx]="radius()" />
      <path
        d="M2046.81 1846.39C1674.58 1872.92 1420.28 1627.92 1181.53 1299.86C967.222 1005.56 793.612 807.777 453.195 823.055V653.611C825.417 627.083 1079.72 872.083 1318.47 1200.14C1532.78 1494.44 1706.39 1692.22 2046.81 1676.94V1846.39Z"
        [attr.fill]="fg()"
      />
    </svg>
  `,
  host: {
    class: 'tw-block tw-w-full tw-h-full',
  },
})
export class EaseLogoIcon {
  /** Background fill color */
  readonly bg = input('var(--color-forest, #0F3E17)');
  /** Foreground/wave fill color */
  readonly fg = input('var(--color-white, #FFFEFC)');
  /** Corner radius (default: 300 = rounded, use 0 for square) */
  readonly radius = input('300');
}
